<template lang="html">
  <div class="excelEr-area">
    <el-dialog :visible.sync="dialogVisible" width="1000px">
      <div class="dialog-area">
        <el-scrollbar style="height: 100%">
          <el-table :data="compData" @row-click="lineCtrls" ref="exStrees" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <template v-if="props.row.remark">
                    <el-form-item class="imptError" label="文件错误：">
                      <span class="active">{{ props.row.remark }}</span>
                    </el-form-item>
                  </template>
                  <template v-else v-for="term in thead2">
                    <el-form-item :label="term.name">
                      <span :class="{ active: errorRed(props.row, term.dataName, term) }">{{
                        props.row | formateData(term.dataName, pressCode)
                      }}</span>
                    </el-form-item>
                  </template>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="导入错误信息列表" prop="readCode"> </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/object";
import { bsParams } from "@/components/LongParams/paramsEt9";
export default {
  props: ["errorList", "pressCode"],
  data() {
    return {
      dialogVisible: false,
      tempHead: [],
      thead2: [],
      erList: [],
      thead: [],
      paramsMap: {
        208: [
          {
            dataName: "type",
            name: "岗位类型",
          },
          {
            dataName: "fullName",
            name: "姓名",
          },
          {
            dataName: "gender",
            name: "性別",
          },
          {
            dataName: "idNumber",
            name: "身份证号",
          },
          {
            dataName: "job",
            name: "职务",
          },
          {
            dataName: "politicalStatus",
            name: "政治面貌",
          },
          {
            dataName: "culture",
            name: "文化程度",
          },
          {
            dataName: "cellphone",
            name: "手机",
          },
          {
            dataName: "major",
            name: "专业",
          },
          {
            dataName: "professionalTitleSeries",
            name: "职称系列",
          },
          {
            dataName: "titleLevel",
            name: "职称级别",
          },
          {
            dataName: "rzDate",
            name: "入职时间",
          },
          {
            dataName: "lzDate",
            name: "离职时间",
          },
          {
            dataName: "certificateSituation",
            name: "持有出版专业技术人员职业资格证书情况",
          },
          {
            dataName: "isTrainCertificate",
            name: "是否持有岗位培训合格证书",
          },
        ],
        301: [
          {
            dataName: "year",
            name: "年份",
          },
          {
            dataName: "publicationName",
            name: "出版物名称",
          },
          {
            dataName: "isbn",
            name: "专用书号ISBN",
          },
          {
            dataName: "carrierForm",
            name: "载体形式",
          },
          {
            dataName: "publicationForm",
            name: "出版形式",
          },
          {
            dataName: "productionUnit",
            name: "节目来源/制作单位",
          },
          {
            dataName: "programCapacity",
            name: "节目时长或容量(分钟/兆)",
          },
          {
            dataName: "publicationQuantity",
            name: "出版数量(张/盒)",
          },
          {
            dataName: "issueQuantity",
            name: "发行数量(张/盒)",
          },
          {
            dataName: "unitPrice",
            name: "发行单价(元)",
          },
          {
            dataName: "publishingTime",
            name: "出版时间",
          },
          {
            dataName: "sampleDelivery",
            name: "是否缴送样本",
          },
          {
            dataName: "sign",
            name: "是否书配盘标记",
          },
        ],

        401: [
          {
            dataName: "materialCode",
            name: "导入编码",
          },
          {
            dataName: "publication",
            name: "出版物名称",
          },
          {
            dataName: "publicationEnglish",
            name: "出版物外文名称",
          },
          {
            dataName: "category",
            name: "类别",
          },
          {
            dataName: "recordType",
            name: "文种",
          },
          {
            dataName: "periodicals",
            name: "刊期",
          },
          {
            dataName: "cn",
            name: "刊号（CN）",
          },
          {
            dataName: "issn",
            name: "国际刊号（ISSN）",
          },
          {
            dataName: "approvalTime",
            name: "批准时间",
          },
          {
            dataName: "mediaForm",
            name: "媒体形态",
          },
          {
            dataName: "mediaFormQT",
            name: "媒体形态其他",
          },
          {
            dataName: "issueQuantity",
            name: "发行数量(套)",
          },
          {
            dataName: "unitPrice",
            name: "发行单价(元)",
          },
          {
            dataName: "isSampleDelivery",
            name: "是否缴送样本",
          },
          {
            dataName: "publicationScope",
            name: "出版范围",
          },
          {
            dataName: "issueScope",
            name: "发行范围",
          },
          {
            dataName: "readers",
            name: "读者对象",
          },
        ],
        404: [
          {
            dataName: "type",
            name: "岗位类型",
          },
          {
            dataName: "fullName",
            name: "姓名",
          },
          {
            dataName: "gender",
            name: "性別",
          },
          {
            dataName: "idNumber",
            name: "身份证号",
          },
          {
            dataName: "job",
            name: "职务",
          },
          {
            dataName: "politicalStatus",
            name: "政治面貌",
          },
          {
            dataName: "culture",
            name: "文化程度",
          },
          {
            dataName: "cellphone",
            name: "手机",
          },
          {
            dataName: "major",
            name: "专业",
          },
          {
            dataName: "professionalTitleSeries",
            name: "职称系列",
          },
          {
            dataName: "titleLevel",
            name: "职称级别",
          },
          {
            dataName: "certificateSituation",
            name: "持有出版专业技术人员职业资格证书情况",
          },
          {
            dataName: "isTrainCertificate",
            name: "是否持有岗位培训合格证书",
          },
        ],
      },
    };
  },

  computed: {
    compData: function () {
      var temps = [];
      for (var i in this.errorList) {
        var tempj = {};
        tempj = this.errorList[i];
        tempj.readCode = "第 " + (parseInt(i) + 1) + " 条错误数据（点击查看）";
        var pattern = /remark/gi;
        /*if(tempj.code == '401' && pattern.test(tempj.errMsg)){
                         tempj.remark = true;
                    }else{
                         tempj.remark = false;
                    }*/
        if (pattern.test(tempj.errMsg)) {
          tempj.remark = tempj.errMsg.split(",")[0].split(":")[1];
        } else {
          tempj.remark = false;
        }
        temps.push(tempj);
      }
      return temps;
    },
  },

  filters: {
    formateData: function (val, val1, code) {
      var es = val.errMsg;
      var cnt = val.content;

      var esTemp = {};
      var cntTemp = JSON.parse(cnt);
      if (es) {
        var arrs = es.split(",");
        for (var i in arrs) {
          if (arrs[i]) {
            esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
          }
        }
      }

      if (esTemp[val1]) {
        return esTemp[val1];
      } else if (cntTemp[val1]) {
        if (val1 == "carrierForm" && cntTemp[val1] == "其他") {
          if (cntTemp["carrierFormQT"]) {
            return cntTemp["carrierFormQT"];
          } else {
            return '请填写"载体形式（其他）"项';
          }
        } else if (val1 == "job" && cntTemp[val1] == "其他") {
          if (cntTemp["professionalOther"]) {
            return cntTemp["professionalOther"];
          } else {
            return '请填写"职务（其他）"项';
          }
        } else {
          return cntTemp[val1];
        }
      }
    },
  },
  methods: {
    handErrors: function () {
      this.dialogVisible = true;
    },

    lineCtrls: function (row, event, column) {
      this.$refs.exStrees.toggleRowExpansion(row);
      this.thead2 = [];
      var storage = deepCopy(this.tempHead);
      for (var termp in storage) {
        this.thead2.push(storage[termp]);
      }
    },

    errorRed: function (val1, val2, val4) {
      var es = val1.errMsg;
      var esTemp = {};

      if (es) {
        var arrs = es.split(",");
        for (var i in arrs) {
          esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
        }

        if (esTemp["mediaFormQT"]) {
          esTemp["mediaForm"] = true;
        }

        if (esTemp["carrierFormQT"]) {
          esTemp["carrierForm"] = true;
        }

        if (esTemp["professionalOther"]) {
          esTemp["job"] = true;
        }
      }

      return esTemp[val2];
    },
  },
  created: function () {
    this.tempHead = [];
    var storage = deepCopy(this.paramsMap[this.pressCode]);
    for (var termp in storage) {
      this.tempHead.push(storage[termp]);
    }
    this.thead2 = this.paramsMap[this.pressCode];
  },
};
</script>

<style lang="scss">
.excelEr-area {
  .el-dialog__body {
    padding: 0px;
  }

  .cell {
    text-align: left !important;
    font-size: 15px;
  }

  .el-dialog__headerbtn {
    top: 12px;
  }

  .el-table__header-wrapper .cell {
    color: red;
  }

  .imptError {
    width: 100% !important;

    .el-form-item__label {
      width: 86px;
    }
  }

  label {
    width: 180px;
    color: #99a9bf;
  }

  .el-form-item {
    margin-right: 0 !important;
    margin-bottom: 0;
    margin-top: 0px;
    width: 49%;
    font-size: 14px;
  }

  .el-form-item__label {
    font-size: 14px;
  }

  .active {
    color: red;
  }

  .dialog-area {
    height: 450px;
    overflow: hidden;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .cell {
    font-size: 14px;
  }

  .el-table__row {
    cursor: pointer;
  }

  .el-form {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// excelError.vue?3fd743b4